// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LeftMenu":"is_a bik_tr","LeftMenu__link":"is_b bik_vt bik_a bik_rc","LeftMenu__link__icon":"is_c"};